// extracted by mini-css-extract-plugin
export default {"unread":"NotificationsList_unread__wD0BL","unreadIcon":"NotificationsList_unreadIcon__jNps4"};